import classNames from 'classnames';
import { ReactNode } from 'react';

import { useTranslations } from '../../lib/i18n/TranslationsProvider';

interface ProductSkuCProps {
	children?: ReactNode;
	className?: string;
}

const ProductSku = ({ children, ...props }: ProductSkuCProps) => {
	const { t } = useTranslations();

	if (!children) return null;

	return (
		<p className={classNames('text-sm', props.className)}>
			<span className="mr-2 inline-block">{t.general.common.sku}:</span>
			<span className="text-center py-1 px-4 mr-2 my-0 text-takeda-medium-grey-600 inline-block">
				{children}
			</span>
		</p>
	);
};

export default ProductSku;
